import { render, staticRenderFns } from "./PointTagModal.vue?vue&type=template&id=a9c4e680&scoped=true&"
import script from "./PointTagModal.vue?vue&type=script&lang=js&"
export * from "./PointTagModal.vue?vue&type=script&lang=js&"
import style0 from "./PointTagModal.vue?vue&type=style&index=0&id=a9c4e680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c4e680",
  null
  
)

export default component.exports